import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * The screenshot component lets us take different types of screenshots with keyboard shortcuts.
 * A-Frame attaches this component to the scene by default
 * so we don’t have to do anything to use the component.
 *
 * @see https://aframe.io/docs/1.3.0/components/screenshot.html
 */

export var Screenshot = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Screenshot, _Component);

  function Screenshot() {
    return _Component.apply(this, arguments) || this;
  }

  return Screenshot;
}(Component);